<template>
  <div>
    <h3>Орчуулсан түүх</h3>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
